import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import GeoExpertPage from './GeoExpertPage';

const GeoExpertView = () => {
  const menuDispatch = useDispatch();

  useEffect(() => {
    menuDispatch({
      type: 'menuSelect',
      payload: 'geo-expert',
    });
  }, []);

  return <GeoExpertPage />;
};

export default GeoExpertView;
